import { type ObjectGraph } from '@jet/environment/dependencies/object-graph';
import type { IntentController } from '@jet/environment/dispatching';
import { type ModifyPlaylistIntent } from './ModifyPlaylistIntent';
import { IntentKind } from '@jet-app/music-classical/intents';
import { NetworkError } from '@jet-app/music-classical/utilities';
import { requestPostAction } from '@jet-app/music-classical/api/request-post-action';
import { createFlowActionForAction } from '@jet-app/music-classical/utilities/create-flow-action';

const ACTION_TYPE_TO_PATH = {
    create: 'create-playlist',
    editPlaylist: 'edit-playlist',
    addToPlaylist: 'add-to-playlist',
};

export const ModifyPlaylistIntentController: IntentController<ModifyPlaylistIntent> =
    {
        $intentKind: IntentKind.MODIFY_PLAYLIST_INTENT,

        async perform(
            intent: ModifyPlaylistIntent,
            objectGraph: ObjectGraph,
        ): Promise<any> {
            const {
                url: actionUrl,
                actionType,
                name,
                songs,
                playlistId,
                description,
            } = intent;
            const url =
                actionUrl ??
                `/query/command/playlist?path=${ACTION_TYPE_TO_PATH[actionType]}`;
            const payload: any = {
                name,
                songs,
                playlistId,
            };

            if (actionType === 'editPlaylist') {
                payload.librarySongs = intent.librarySongs;
                payload.offset = intent.offset;
            }

            if (description) {
                payload.description = description;
            }

            const apiResponse = await requestPostAction(
                url,
                payload,
                objectGraph,
            );

            if (!apiResponse?.body) {
                throw NetworkError.noContent();
            }

            if (actionType === 'create') {
                // If ActionType is create, then return a segue with FlowAction to redirect to Library Playlist`
                return {
                    type: apiResponse?.body?.type,
                    title: apiResponse?.body?.title,
                    segue: createFlowActionForAction(
                        apiResponse?.body?.action,
                        objectGraph,
                    ),
                };
            }

            return apiResponse.body;
        },
    };
